import constructImage from "../../assets/images/2938119-Photoroom.png";
import gearImage from "../../assets/images/gear.png";

export default function UnderConstruction() {
  return (
    <>
      <div className="flex min-h-screen flex-col items-center justify-center p-6 md:flex-row md:px-[14vw]">
        <img
          src={gearImage}
          alt="gear"
          className="absolute right-[30%] top-[10%] -z-10 h-28 w-28 animate-spin-slow opacity-30"
        />
        <img
          src={gearImage}
          alt="gear"
          className="absolute left-[8%] top-[20%] -z-10 h-16 w-16 animate-spin-reverse opacity-50"
        />
        <img
          src={gearImage}
          alt="gear"
          className="absolute bottom-[25%] left-[25%] -z-10 h-10 w-10 animate-spin-slow opacity-40"
        />
        <img
          src={gearImage}
          alt="gear"
          className="absolute bottom-[15%] right-[12%] -z-10 h-20 w-20 animate-spin-reverse opacity-30"
        />

        <div className="max-w-xl flex-1 text-center md:text-left">
          <h1 className="text-primary-text mb-3 text-3xl font-bold md:mb-14 md:text-[68px]">
            Oops!
          </h1>
          <h1 className="text-primary-text text-3xl font-semibold md:text-5xl md:!leading-[64px]">
            Website is{" "}
            <span className="font-bold text-primary">Under Maintenance </span>
          </h1>
          <p className="mt-4 text-xl leading-relaxed text-gray-500">
            Hi there! Our site is undergoing a maintenance right now. Please
            come back later. Thank you for your patience.
          </p>
        </div>

        <div className="mt-8 flex flex-1 justify-center md:mt-0">
          <img
            src={constructImage}
            alt="Under Construction"
            className="w-full animate-jump rounded-full md:max-w-[30vw]"
          />
        </div>
      </div>
    </>
  );
}
